'use client'

import React from 'react'
import { LinkButton } from '@/components/ui/LinkButton'
import { DiscordIcon } from '@/components/icons/DiscordIcon'
import { GitHubIcon } from '@/components/icons/GitHubIcon'

export function IconNavItems() {
  return (
    <>
      <LinkButton
        newTab
        href="https://discord.gg/sia"
        variant="ghost"
        size="clear"
        className="hover:scale-110 transition-all duration-100 hover:text-punch"
      >
        <DiscordIcon className="w-6 h-6" />
      </LinkButton>
      <LinkButton
        newTab
        href="https://github.com/siafoundation"
        variant="ghost"
        size="clear"
        className="hover:scale-110 transition-all duration-100 hover:text-punch"
      >
        <GitHubIcon className="w-6 h-6" />
      </LinkButton>
    </>
  )
}
